import { CurrentUserEntriesAndStats } from 'components/dashboard/EntriesAndStats/EntriesAndStats';
import HeaderProfile from 'components/dashboard/header-profile/HeaderProfile';
import MainLayout from 'components/layout/MainLayout';
import { useAuthRedirectEffect } from 'hooks/account/useAuthRedirect';
import { observer } from 'mobx-react-lite';
import { Fragment, ReactElement, useEffect, useState } from 'react';

import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import { DashboardInstagramFeed } from 'components/dashboard/DashboardInstagramFeed';
import DashboardLinks from 'components/dashboard/DashboardLinks';
import { MoreWaysToWin } from 'components/dashboard/MoreWaysToWin';
import { CurrentUserTreeProgression } from 'components/dashboard/TreeProgression';
import WinsAndMonthly from 'components/dashboard/WinsAndMonthly';
import YourWishlist from 'components/dashboard/your-wishlist/YourWishlist';
import styles from './dashboard.module.css';

interface Dashboard2026Props {
  children: ReactElement;
  variant?: string | undefined;
}

const Dashboard2026 = observer((props: Dashboard2026Props) => {
  useAuthRedirectEffect('/dashboard/2026');
  const [dashboardLoading, setDashboardLoading] = useState(true);

  useEffect(() => {
    if (dashboardLoading) {
      setTimeout(() => {
        setDashboardLoading(false);
      }, 1000);
    }
  }, [dashboardLoading]);

  if (props.children && props.variant !== 'V1') {
    // Allow our default branch to always show the existing dashboard
    return props.children;
  }

  // Allow the new dashboard to appear outside of plasmic's catchall when the time comes. When props.children is set,
  // the component will be inside plasmic's CatchAll which provides the MainLayout. Otherwise, we have to provide our
  // own
  const Wrapper = props.children ? Fragment : MainLayout;

  return (
    <Wrapper
      {...(!props.children
        ? { limitItemWidths: true, noHeaderDropShadow: true }
        : {})}
    >
      <div
        className={`aboutUsTypographyReset ${styles.outerContainer}`}
        style={{
          // Make the component go "full-bleed" in plasmic's container. We can probably remove this once the dashboard
          // page lives outside of plasmic
          width: '100%',
          gridColumn: '1 / 8',
          // Make the component be at least one-screen-height tall, like the plasmic variant. We can probably remove this
          // once the dashboard page lives outside of plasmic
          minHeight: '100vh',
        }}
      >
        {/* PROFILE INFO & EDIT PROFILE */}
        <HeaderProfile loading={dashboardLoading} />
        {/* ENTRIES & STATS */}
        <CurrentUserEntriesAndStats loading={dashboardLoading} />
        {/* YOUR WINS & MONTHLY 10k */}
        <WinsAndMonthly loading={dashboardLoading} />
        {/* MORE WAYS TO WIN (TOKEN TOWN DRAWS) */}
        <MoreWaysToWin loading={dashboardLoading} />

        {/* TREES & WISHLIST */}
        {!dashboardLoading && (
          <AboutUsModule background="grey" withReducedPadding>
            <AboutUsSiteContainer overlapAbove twoColumn>
              <div className={styles.dashboardTreeContainer}>
                <CurrentUserTreeProgression />
              </div>
              <div className={styles.dashboardWishlistContainer}>
                <YourWishlist />
              </div>
            </AboutUsSiteContainer>
          </AboutUsModule>
        )}

        {/* INSTAGRAM FEED */}
        <DashboardInstagramFeed loading={dashboardLoading} />

        {/* LINKS */}
        <DashboardLinks loading={dashboardLoading} />
      </div>
    </Wrapper>
  );
});

export default Dashboard2026;
